import React, { useState, useEffect } from "react";
import Header from "../../../componentes/header/header";
import FinalComponent from "../../../componentes/EndPage/Final";
import JsonDataConpeex from "./anaisConpeex.json";  
import translations from "./traducao.json";  

function Anais() {
    const [langConpeex, setLangConpeex] = useState(localStorage.getItem("siteLanguage") || 'pt'); 
    const [dataConpeex, setDataConpeex] = useState([]); 
    const [translatedText, setTranslatedText] = useState({}); 


    const handleLanguageChange = (newLangConpeex) => {
        setLangConpeex(newLangConpeex);
        localStorage.setItem("siteLanguage", newLangConpeex); 
        window.location.reload(); 
    };

    useEffect(() => {
  
        setDataConpeex(JsonDataConpeex[langConpeex]);
        
        // Carrega as traduções baseadas no idioma
        setTranslatedText(translations[langConpeex] || translations["pt"]); 
    }, [langConpeex]); 

    return (
        <>
            <Header handleLanguageChange={handleLanguageChange} />
           <div
            className="
                flex flex-col items-start 
                mt-[6vh] mb-[6vh]
                max-[1440px]:mt-[22vh]
                max-[1024px]:mt-[22vh]
                max-[768px]:mt-[24vh]
                max-[480px]:mt-[30vh]

                max-[1440px]:mb-[5vh]
                max-[1024px]:mb-[4vh]
                max-[768px]:mb-[3vh]
                max-[480px]:mb-[2vh]
            "
            >
            <div
                className="
                border-l-[10px] border-l-[#FF8989] pl-[30px] text-left m-0 
                mx-[25%]
                max-[1440px]:mx-[20%]
                max-[1024px]:mx-[15%]
                max-[768px]:mx-[10%]
                max-[480px]:mx-[5%]
                "
            >
                <p
                className="
                    mt-[10px] text-[#6A0DAD] font-black mb-6 
                    text-[5vh]
                    max-[1440px]:text-[4.5vh]
                    max-[1024px]:text-[4vh]
                    max-[768px]:text-[3.5vh]
                    max-[480px]:text-[3vh]
                "
                >
                {translatedText.title}
                </p>
                <p
                className="
                    mt-0 text-black font-normal 
                    text-[32px]
                    max-[1440px]:text-[30px]
                    max-[1024px]:text-[26px]
                    max-[768px]:text-[22px]
                    max-[480px]:text-[18px]
                "
                >
                {translatedText.subTitle}
                </p>
            </div>
            </div>


            <p className="text-[4vh] font-black text-[#B040B1] inline-block relative mb-[3vh]">
                {translatedText.conpeex}
                <span className="absolute bottom-[-8px] left-[-15px] w-[120%] h-[5px] bg-gradient-to-r from-[#6A0DAD] to-[#FF66B2] rounded-[2px]"></span>
            </p>

            <div>
                {dataConpeex.map((item, index) => (
                    <div key={index} className="bg-white p-5 m-5 mx-auto text-left rounded-[10px] shadow-[0px_4px_10px_rgba(0,0,0,0.2)] border-l-[5px] border-l-[#6A0DAD] max-w-[60%] mb-[3%] w-[90%] z-0">
                        <h2 className="text-[1.5em] font-bold text-[#6A0DAD] mb-[10px]">{item.name}</h2>
                        <p className="text-[1.1em] font-bold text-[#FF8989] mb-[10px]">{item.data} CONPEEX</p>
                        <p>{translatedText.author}: {item.autores}</p>
                        <p>{item.conteudo}</p>
                        <div className="flex gap-5"> 
                            <a href={item.linker} className="inline-block text-[#B040B1] no-underline font-bold hover:underline" target="_blank" rel="noopener noreferrer">
                                <p>{item.acesseconpeex}</p>
                            </a>

                            <a href={item.pdf} className="inline-block text-[#B040B1] no-underline font-bold hover:underline" target="_blank" rel="noopener noreferrer">
                                <p>{item.acesse}</p>
                            </a>
                        </div>
                    </div>
                ))}
            </div>

            <FinalComponent />
        </>
    );
}

export default Anais;
